<script>
import { deviceEventCurrentComputed, infoDetailsMethods } from '@state/helpers'
import DeviceEventEntities from '@components/info-side-details-device-state-entities'

import {
  statusCssClass,
  statusCssTextClass,
  statusCssCardAccentClass,
} from '@utils/design/status-css-classes'

import { cycleCssClass } from '@utils/design/cycle-css-classes'

import {
  durationSinceEvent,
  futureTimeOfEvent,
  formatPrettyDateTime,
} from '@utils/data/date-time'

import { cyclePercentage } from '@utils/data/cycle'

export default {
  components: { DeviceEventEntities },

  props: {
    deviceEventCurrent: {
      type: Object,
      default: () => {},
    },
  },

  data: function() {
    return {
      statusCssTextClass: null,
      statusCssBackgroundClass: null,
      statusCssCardAccentClass: null,
    }
  },

  computed: {
    ...deviceEventCurrentComputed,

    cyclePercentageComputed: function() {
      return cyclePercentage(this.$moment, this.deviceEventCurrent.cycle, Date.now())
    },

    durationSinceEventComputed: function() {
      return durationSinceEvent(this.$moment, this.deviceEventCurrent.startDate)
    },

    cycleCssClassComputed: function() {
      return cycleCssClass(this.cyclePercentageComputed)
    },
    getStatusCssClass: function() {
      return statusCssClass(this.deviceEventCurrent.status.type)
    },
  },

  updated: function() {
    this.processDeviceEventCurrent()
  },

  created: function() {
    this.processDeviceEventCurrent()
  },

  methods: {
    ...infoDetailsMethods,

    processDeviceEventCurrent: function() {
      if (this.deviceEventCurrent) {
        this.statusCssTextClass = statusCssTextClass(this.deviceEventCurrent.status.type)

        this.statusCssCardAccentClass = statusCssCardAccentClass(
          this.deviceEventCurrent.status.type
        )
      }
    },

    datePretty: function(date) {
      return formatPrettyDateTime(date)
    },

    cycleFutureDate: function(date, duration) {
      return formatPrettyDateTime(futureTimeOfEvent(this.$moment, date, duration))
    },
  },
}
</script>

<template>
  <div>
    <b-card-body
      v-if="deviceEventCurrent"
      class="animated fadeIn card info-card card-body device-card-body-info pt-2 mb-0 p-0 pb-3 clearfix"
    >
      <b-row class="ml-0 mr-0 device-info-row">
        <b-col class="h5 pl-3 mb-0  text-uppercase pt-1">
          {{ deviceEventCurrent.device.name }}
          <span :class="statusCssTextClass"> {{ deviceEventCurrent.status.name }}</span>

          <span v-if="deviceEventCurrent.status.type != 1" class="text-uppercase  mb-0">
            {{ durationSinceEventComputed }}
          </span>
        </b-col>
      </b-row>
    </b-card-body>
    <b-tabs>
      <b-tab title="Process" active>
        <b-card-body
          v-if="deviceEventCurrent"
          class="animated fadeIn card info-card card-body device-card-body-info p-0 pt-3 pb-2 mb-3 clearfix"
        >
          <span class="w-100 font-weight-bold  btn-block text-muted float-right  pl-3">
            ACTIVITY
          </span>
          <div class="text-uppercase h5 pb-0 pl-3 pr-3 pt-1 mb-0">
            <p class="mb-1"> {{ deviceEventCurrent.activity.name }}</p>
            <b-badge
              class="mr-2 mt-2"
              :variant="
                deviceEventCurrent.activity.planned == true ? 'success' : 'danger'
              "
            >
              Planned
            </b-badge>
            <b-badge
              class="mr-2"
              :variant="
                deviceEventCurrent.activity.available == true ? 'success' : 'danger'
              "
              >Available
            </b-badge>
          </div>

          <div class="text-uppercase font-weight-bold   pt-2 pl-3 pr-3 pb-2">
            <span class="float-right"
              >{{ deviceEventCurrent.shiftPattern.name }} SHIFT</span
            >
            <span class="font-weight-bold  btn-block text-muted ">
              Rate:
              <span class="text-success">{{ deviceEventCurrent.cycleRate }}%</span>
            </span>
          </div>
        </b-card-body>

        <b-card-body
          v-if="deviceEventCurrent"
          class="animated fadeIn card info-card card-body device-card-body-info p-0  pb-3 mb-3 clearfix"
        >
          <span
            class="w-100 btn-block font-weight-bold text-muted float-right pb-0 pb-1 pl-3"
          >
            CYCLE
          </span>
          <div class="pl-3 pr-3 pt-0 pb-0">
            <b-progress
              class="progress-xs progress-xs-cycle  my-1 mt-1"
              :variant="cycleCssClassComputed"
              :value="cyclePercentageComputed"
            />

            <div
              v-if="cyclePercentageComputed <= 100"
              class="text-uppercase float-right font-weight-bold"
            >
              {{ cyclePercentageComputed }}%
            </div>
            <div v-if="cyclePercentageComputed > 100" class="text-uppercase float-right ">
              > 100%
            </div>

            <div class="text-uppercase ">
              <span class=" font-weight-bold ">
                {{ deviceEventCurrent.cycle.name }}
              </span>
            </div>
          </div>

          <span
            class="w-100 font-weight-bold  btn-block text-muted float-right mt-2 pb-0 pl-3"
          >
            COUNT
          </span>
          <b-row class="ml-0 mr-0 device-info-row">
            <b-col class=" font-weight-bold pl-3 mb-0  text-uppercase">
              <span v-if="deviceEventCurrent.cycle.count != null" class="clearfix">
                {{ deviceEventCurrent.cycle.count }}
                <span v-if="deviceEventCurrent.cycle.total" class="text-muted">
                  / {{ deviceEventCurrent.cycle.total }}
                </span>
              </span>
              <span v-else class="clearfix">
                --
              </span>
            </b-col>
          </b-row>

          <span
            v-if="deviceEventCurrent.cycle.start !== deviceEventCurrent.cycle.countStart"
            class="w-100 font-weight-bold  btn-block text-muted float-right pt-2 pb-0 pl-3"
          >
            CURRENT START
          </span>
          <b-row
            v-if="deviceEventCurrent.cycle.start !== deviceEventCurrent.cycle.countStart"
            class="ml-0 mr-0  device-info-row"
          >
            <b-col class=" font-weight-bold pl-3 mb-0  text-uppercase">
              <span class="clearfix">
                {{ datePretty(deviceEventCurrent.cycle.countStart) }}
              </span>
            </b-col>
          </b-row>
          <span
            v-if="deviceEventCurrent.cycle.forecastDurationMinutes"
            class="w-100 font-weight-bold  btn-block text-muted float-right pt-2 pb-0 pl-3"
          >
            FORECAST FINISH
          </span>
          <b-row
            v-if="deviceEventCurrent.cycle.forecastDurationMinutes"
            class="ml-0 mr-0  device-info-row"
          >
            <b-col class=" pl-3 mb-0 font-weight-bold  text-uppercase pt-0">
              <span class="clearfix">
                {{
                  cycleFutureDate(
                    deviceEventCurrent.cycle.countStart,
                    deviceEventCurrent.cycle.forecastDurationMinutes
                  )
                }}
              </span>
            </b-col>
          </b-row>
          <span
            class="w-100 font-weight-bold  btn-block text-muted float-right pt-2 pb-0 pl-3"
          >
            CYCLE START
          </span>
          <b-row class="ml-0 mr-0  device-info-row">
            <b-col class=" font-weight-bold pl-3 mb-0  text-uppercase">
              <span v-if="deviceEventCurrent.cycle.start != null" class="clearfix">
                {{ datePretty(deviceEventCurrent.cycle.start) }}
              </span>
              <span v-else class="clearfix">
                --
              </span>
            </b-col>
          </b-row>
        </b-card-body>
      </b-tab>

      <b-tab title="Entities">
        <DeviceEventEntities class="pt-2" :device-event-current="deviceEventCurrent" />
      </b-tab>
    </b-tabs>
  </div>
</template>

<style lang="scss">
.device-info {
  min-width: 145px;
  max-height: 65px;
  overflow: hidden;
}
.device-info-row {
  overflow: hidden;
}
.device-card-body-info {
  overflow: hidden;
  border-radius: 0 !important;
}

.b-card-body:hover {
  z-index: 1;
  color: #e4e7ea;
  text-decoration: none;
  background-color: #2f353a;
}
::selection {
  background: #000; /* WebKit/Blink Browsers */
}
::-moz-selection {
  background: #000; /* Gecko Browsers */
}
.aside-menu .nav-tabs .nav-link {
  font-size: 1.09375rem !important;
  text-transform: uppercase !important;
  font-weight: 500 !important;
}
.progress-xs-cycle {
  min-height: 12px;
}
</style>
